import { Inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import {
  AuthenticationResult,
} from '@azure/msal-browser';
import { Observable, firstValueFrom, map } from 'rxjs';
import { CLIENT_CONFIG, ClientConfig } from '../../appconfig/client-config';

@Injectable({
  providedIn: 'root',
})
export class BearerService {
  private readonly messages = {
    noAccounts: 'No accounts logged in.',
  }

  constructor(private msalService: MsalService,
    @Inject(CLIENT_CONFIG) private clientConfig: ClientConfig) {}

  /**
   * get msal auth token as string
   * @returns get token as promise
   */
  async getTokenAsync(): Promise<string> {
    const accounts = this.msalService.instance.getAllAccounts();

    if (accounts.length === 0) {
      throw new Error(this.messages.noAccounts);
    }

    const request = {
      scopes: this.clientConfig.clientOptions.msalResourceMap[0][1],
      account: accounts[0],
    };

    const response: any = await firstValueFrom(
      this.msalService.acquireTokenSilent(request)
    );

    return response.accessToken;
  }

  /**
   * get msal auth token as string
   * @returns {Observable<string | undefined>}
   */
  getTokenObservable(): Observable<string | undefined> {
    const accounts = this.msalService.instance.getAllAccounts();

    if (accounts.length === 0) {
      throw new Error(this.messages.noAccounts);
    }

    const request = {
      scopes: this.clientConfig.clientOptions.msalResourceMap[0][1],
      account: accounts[0],
    };

    return this.msalService
      .acquireTokenSilent(request)
      .pipe(map((response) => response.accessToken));
  }

  /**
   * get token auth request as promise
   * @returns get token as promise
   */
  getTokenPromise(): Promise<AuthenticationResult> {
    const accounts = this.msalService.instance.getAllAccounts();

    if (accounts.length === 0) {
      throw new Error(this.messages.noAccounts);
    }

    const request = {
      scopes: this.clientConfig.clientOptions.msalResourceMap[0][1],
      account: accounts[0],
    };

    return firstValueFrom(this.msalService
      .acquireTokenSilent(request));
  }
}
